namespace GeniuzPOS.InventoryReport {
    export interface IcReport07SkuWhsRow {
        Id?: string;
        RowRunNo?: number;
        SkuCode?: string;
        ShopId?: string;
        WhsId?: string;
        TranDate?: string;
        SysDocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        TranType?: string;
        QtyAdd?: number;
        QtyDel?: number;
        QtyBalance?: number;
        CostAdd?: number;
        CostDel?: number;
        CostBalance?: number;
    }

    export namespace IcReport07SkuWhsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport07SkuWhs';
        export const deletePermission = '2Inventory:รายงาน:รายงานสต๊อกการ์ด:View';
        export const insertPermission = '2Inventory:รายงาน:รายงานสต๊อกการ์ด:View';
        export const readPermission = '2Inventory:รายงาน:รายงานสต๊อกการ์ด:View';
        export const updatePermission = '2Inventory:รายงาน:รายงานสต๊อกการ์ด:View';

        export declare const enum Fields {
            Id = "Id",
            RowRunNo = "RowRunNo",
            SkuCode = "SkuCode",
            ShopId = "ShopId",
            WhsId = "WhsId",
            TranDate = "TranDate",
            SysDocNo = "SysDocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            TranType = "TranType",
            QtyAdd = "QtyAdd",
            QtyDel = "QtyDel",
            QtyBalance = "QtyBalance",
            CostAdd = "CostAdd",
            CostDel = "CostDel",
            CostBalance = "CostBalance"
        }
    }
}
